import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/ZepSchoolColorPrimary.tsx
const ZepSchoolColorPrimaryIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.29 10.006c.397-1.66.257-3.218-.518-4.453-1.033-1.641-3-2.39-5.337-2.27-1.762-1.839-3.9-2.692-5.921-2.094-1.656.488-2.96 1.865-3.787 3.762-1.973.73-3.441 2.043-3.995 3.813-.462 1.482-.217 3.067.58 4.56-.644 1.939-.595 3.793.3 5.214 1.129 1.793 3.369 2.519 5.99 2.215 1.754 1.814 3.875 2.651 5.884 2.058 1.655-.488 2.96-1.865 3.786-3.762 1.973-.73 3.442-2.043 3.995-3.813.534-1.706.127-3.549-.98-5.23h.003Z",
		fill: "#6758FF"
	}), /* @__PURE__ */ jsx("path", {
		d: "M11.98 17.17c-2.222 0-3.507-.799-3.931-1.763a1.649 1.649 0 0 1-.15-.683c0-.698.526-1.176 1.244-1.176.546 0 .916.17 1.305.718.342.485.916.683 1.566.683.868 0 1.401-.355 1.401-.84 0-.465-.383-.664-1.49-.862l-.991-.178c-1.962-.348-3.036-1.34-3.036-2.87 0-1.983 1.71-3.234 4.054-3.234 1.955 0 3.357.69 3.87 1.92.081.199.122.384.122.61 0 .655-.478 1.1-1.203 1.107-.615 0-1.005-.212-1.353-.739-.322-.492-.78-.676-1.402-.676-.806 0-1.216.355-1.216.8 0 .444.423.656 1.408.833l.99.178c2.12.383 3.118 1.251 3.118 2.85 0 2.03-1.586 3.323-4.307 3.323Z",
		fill: "#fff"
	})]
}));
export { ZepSchoolColorPrimaryIcon };
